import { jsx } from "react/jsx-runtime";
import { Box, Text } from "braid-design-system";
import { dateButton, dateButtonInactive } from "./DateButton.css.mjs";
const DateButtonInactive = ({
  children
}) => /* @__PURE__ */ jsx(Box, { display: "block", paddingX: "xxsmall", position: "relative", marginY: "xxsmall", children: /* @__PURE__ */ jsx(
  Box,
  {
    borderRadius: "full",
    className: [dateButton, dateButtonInactive],
    component: "button",
    disabled: true,
    outline: "none",
    children: /* @__PURE__ */ jsx(Text, { size: "small", children })
  }
) });
export {
  DateButtonInactive
};
